<ng-container *ngIf="{isTop: isTopNav$ | async} as navigation">
  <div class="navbar-top" [ngClass]="{'open' : !isCollapsed}">
    <div class="container--nav">
      <div class="d-flex">
        <div class="d-flex align-items-center me-auto">
          <a [core-analytics]="{action: 'Home', category: 'TOP-NAV'}" class="navbar-brand"
             routerLink="/"
          >
            <img [alt]="getSiteName() + ' logo'" [src]="logoUrl | cdn" class="navbar-logo">
          </a>
        </div>

        <div class="d-flex align-items-center">

          <core-search *ngIf="searchEnabled" [isSearchButtonIcon]="true"></core-search>

          <core-notifications *ngIf="notificationsEnabled && navigation.isTop"></core-notifications>

          <core-dark-mode-toggle></core-dark-mode-toggle>

          <a *ngIf="contactEnabled" routerLink="/contact"
             [core-analytics]="{action: 'Get in touch', category: 'TOP-NAV'}"
             class="btn btn-primary btn--small mb-0 d-none d-lg-block ms-3">{{'Get in touch?' | translate}}</a>

          <a *ngIf="isLoggedIn" href="javascript:void(0)" (click)="logout()"
             [core-analytics]="{action: 'Logout', category: 'TOP-NAV'}"
             class="btn btn-dark btn--icon-right btn--small mb-0 d-none d-lg-block ms-3">{{'Logout' | translate}}
            <span class="material-symbols-outlined">
              {{'Logout' | translate}}
              </span>
          </a>

          <button id="mobile-nav-icon"
                  (click)="toggleMobileMenu($event)"
                  [attr.aria-expanded]="!isCollapsed"
                  [core-analytics]="{action: 'Toggle navigation', category: 'TOP-NAV'}"
                  [ngClass]="{'open' : !isCollapsed, 'navbar-toggler--dark': !heroImagesEnabled}"
                  aria-controls="navbarSupportedContent"
                  aria-label="Toggle navigation"
                  class="navbar-toggler ms-3"
                  type="button">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

      </div>

    </div>
  </div>

  <nav class="navbar navbar-expand-lg" role="navigation">
    <div class="container--nav navbar__inner">
      <div class="collapse navbar-collapse"
           [ngClass]="{'navbar-remove-scroll': resetMobileScroll, 'is-mobile-nav-footer': isMobileNavFooter}"
           [collapse]="isCollapsed">
        <core-search (closeTopnavHamburgerNav)="isCollapsed = !isCollapsed"
                     *ngIf="searchEnabled"
                     [isSearchButtonIcon]="false"
                     class="core-search-form--mobile"></core-search>
        <ul class="navbar-nav d-flex w-100">
          <ng-container *ngIf="pages$ | async as _pages">
            <ng-container *ngFor="let page of _pages | orderBy:['displayOrder'] trackBy: trackByFn index as i">

              <!-- Top nav links without child pages -->
              <ng-container *ngIf="page.children.length === 0 || page.meta.hideNavDropdown">
                <li class="nav-item"
                    *ngIf="showInMenu(page, 'no-child')"
                    [ngClass]="{'nav-item--posts' : isDemoModeAndPostsLink(page)}">
                  <a class="nav-link" aria-current="page"
                     [id]="page.url"
                     [ngClass]="{'is-active' : setTopNavActiveLinkState(page), 'active' : setTopNavActiveLinkState(page)}"
                     (click)="navigateToPage(page.url)"
                     [core-analytics]="{action: page.url, category: 'TOP-NAV'}"
                     href="javascript:void(0)">
                    {{page.meta.friendlyPageName || page.name}}
                  </a>
                </li>

                <!-- ** THIS <li> DOESN'T GET USED FOR CLIENT BUILDS!! **
                Split out <li> for 'posts' demo toggle purposes only. This only gets used during demo mode. -->
                <li class="nav-item"
                    *ngIf="isDemoMode && page.url === 'posts' && postsEnabled">
                  <a aria-current="page" class="nav-link nav-link--posts-demo"
                     id="{{page.url}}"
                     (click)="navigateToPage(page.url)"
                     [core-analytics]="{action: page.url, category: 'TOP-NAV'}"
                     href="javascript:void(0)">
                    {{page.meta.friendlyPageName || page.name}}
                  </a>
                </li>
              </ng-container>

              <!-- Top nav links with child pages -->
              <ng-container *ngIf="page.children.length > 0">
                <li
                  *ngIf="showInMenu(page, 'has-child')"
                  class="nav-item dropdown"
                  (isOpenChange)="onOpenChange($event, i)"
                  (onShown)="onDropdownOpen()"
                  [core-analytics]="{action: 'Toggle ' + page.name, category: 'TOP-NAV'}"
                  dropdown>
                  <a href="javascript:void(0)"
                     class="nav-link dropdown-toggle page-dropdown-{{page.url}}"
                     id="navbarDropdown" role="button" aria-expanded="false"
                     [ngClass]="{'is-active' : setTopNavActiveLinkState(page)}"
                     #navbarDropdown
                     dropdownToggle>
                    {{page.name}}
                  </a>

                  <ng-container *ngIf="pillars$ | async as content">
                    <div
                      id="dropdown"
                      class="dropdown-menu"
                      [ngClass]="{'dropdown-mobile' : !isDesktop}"
                      *dropdownMenu
                      aria-labelledby="navbarDropdown"
                      [core-analytics]="{action: 'Toggle ' + page.name, category: 'TOP-NAV'}"
                      (click)="stopPropagation($event)">
                      <!-- Container for dropdown content to adjust width for thumbnail posts when enabled.
                      This class breaks the dropdown if applied on the 'dropdown-menu' div above so adding as a new div here. -->
                      <div [ngClass]="{'dropdown-menu__with-posts': postsInNavEnabled}">
                        <ng-container *ngIf="isCategoryNav && page.url === 'benefits' && content.length > 1">
                          <div class="dropdown-wrapper activeMenuTab-{{activeMenuTab.value}} benefits w-100">
                            <mat-tab-group (selectedIndexChange)="activeMenuTab.setValue($event)"
                                           class="nav nav-menu-tabs mx-auto"
                                           mat-align-tabs="left">
                              <mat-tab *ngFor="let item of content; trackBy: trackByFn"
                                       [core-analytics]="{action: item.name, category: 'TOP-NAV'}"
                              >
                                <ng-template mat-tab-label>
                                  <div [class]="'pillar-icon pillar-icon--' + parsePillarClass(item.name)"></div>
                                  <span [innerHTML]="item.name" class="pillar-title"></span>
                                </ng-template>
                                <div class="nav-menu-wrapper w-100 nav-menu-wrapper--{{activeMenuTab.value}}">
                                  <div class="row w-100">
                                    <ng-container *ngFor="let page of item.pageCategories | orderBy:['name']">
                                      <ng-container *ngIf="showInMenu(page, 'no-child')">
                                        <div class="nav-menu-item col-md-4 col-xl-3">
                                          <a (click)="navigateToPage(page.url)"
                                             [attr.aria-label]="'Learn more about ' + page.name"
                                             [ngClass]="{'active' : setDropdownActiveLinkState(page)}"
                                             class="nav-menu-item__link"
                                             [core-analytics]="{action: page.url, category: 'TOP-NAV'}"
                                             href="javascript:void(0)">
                                            <span [innerText]="page.name" class="nav-menu-item__name"></span>
                                          </a>
                                        </div>
                                      </ng-container>
                                    </ng-container>
                                  </div>
                                </div>
                              </mat-tab>
                            </mat-tab-group>
                            <a (click)="navigateToPage('benefits')" class="btn btn-primary btn-viewall"
                               [core-analytics]="{action: 'View all benefits', category: 'TOP-NAV'}"
                               href="javascript:void(0)">View all benefits</a>
                          </div>
                        </ng-container>

                        <ng-container
                          *ngIf="!isCategoryNav || (page.url !== 'benefits' && content.length > 1)">
                          <ng-container *ngIf="page.url !== 'life-journeys'">
                            <div class="dropdown-wrapper dropdown-wrapper--no-category-nav">
                              <div class="nav-menu-wrapper nav-menu-wrapper--{{activeMenuTab.value}} h-auto">
                                <div class="row w-100">
                                  <ng-container *ngFor="let page of page.children | orderBy:['name']">
                                    <ng-container *ngIf="showInMenu(page, 'no-child')">
                                      <div class="nav-menu-item col-md-4 col-xl-3">
                                        <a (click)="navigateToPage(page.url)"
                                           [attr.aria-label]="'Learn more about ' + page.name"
                                           [ngClass]="{'active' : setDropdownActiveLinkState(page)}"
                                           class="nav-menu-item__link"
                                           [core-analytics]="{action: page.url, category: 'TOP-NAV'}"
                                           href="javascript:void(0)">
                                          <span [innerText]="page.name" class="nav-menu-item__name"></span>
                                        </a>
                                      </div>
                                    </ng-container>
                                  </ng-container>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="page.url === 'life-journeys'">
                            <div class="dropdown-wrapper dropdown-wrapper--no-category-nav life-journeys">
                              <div class="nav-menu-wrapper nav-menu-wrapper--{{activeMenuTab.value}} h-auto">
                                <div class="row h-100 g-2">
                                  <div *ngFor="let page of page.children | orderBy:['name']"
                                       class="nav-menu-item col-12 col-md-3 d-flex">
                                    <a (click)="navigateToPage(page.url)"
                                       [attr.aria-label]="'Learn more about ' + page.name"
                                       [ngClass]="{'active' : setDropdownActiveLinkState(page)}"
                                       [core-analytics]="{action: page.url, category: 'TOP-NAV'}"
                                       class="nav-menu-item__link flex-column"
                                       href="javascript:void(0)">

                                      <span class="nav-menu-item__name">{{page.name}}</span>
                                      <span class="nav-menu-item__desc">{{page.description | limitTo: 85}}</span>
                                      <span class="nav-menu-item__icon">
                                          <img *ngIf="page.meta.icon" [alt]="page.name" [src]="page.meta.icon | cdn">
                                        </span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>

                      <div class="dropdown-wrapper-mobile">
                        <core-search (closeTopnavHamburgerNav)="isCollapsed = !isCollapsed"
                                     *ngIf="searchEnabled"
                                     class="core-search-form--mobile"></core-search>

                        <ng-container *ngIf="isCategoryNav && page.children.length > 0">
                          <div class="nav-menu-item-back d-flex align-items-center" (click)="closeChildDropdown()">
                            <svg width="52" height="50" viewBox="0 0 52 50" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <rect width="52" height="50" rx="25" fill="#F0F1F2"/>
                              <mask id="mask0_583_15973" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="20"
                                    y="16" width="12" height="18">
                                <rect x="20" y="16" width="12" height="18" fill="#D9D9D9"/>
                              </mask>
                              <g mask="url(#mask0_583_15973)">
                                <path d="M28 32.5L20.5 25L28 17.5L29.3313 18.8313L23.1625 25L29.3313 31.1688L28 32.5Z"
                                      fill="#1C1B1F"/>
                              </g>
                            </svg>
                            <div [innerText]="page.name" class="ps-3"></div>
                          </div>
                          <ul class="benefits-nav-list">
                            <li
                              *ngFor="let page of page.children | orderBy:['name']; trackBy: trackByFn; let i = index;"
                              class="benefits-nav-list__item">
                              <a (click)="navigateToPage(page.url)"
                                 href="javascript:void(0)"
                                 [core-analytics]="{action: page.url, category: 'TOP-NAV'}"
                                 [innerText]="page.name"></a>
                            </li>
                          </ul>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                </li>
              </ng-container>
            </ng-container>
          </ng-container>

          <li *ngIf="isLoggedIn && !isDesktop" class="nav-item">
            <a href="javascript:void(0)" (click)="logout()"
               [core-analytics]="{action: 'Logout', category: 'TOP-NAV'}"
               class="nav-link d-flex align-items-center">{{'Logout' | translate}}
              <span class="material-symbols-outlined ms-1">
              {{'Logout' | translate}}
              </span>
            </a>
          </li>

          <div #fixedMobileNavFooter *ngIf="!isCollapsed && isMobileNavFooter" class="fixed-mobile-nav-footer">
            <span class="nav-link">
              <a *ngIf="contactEnabled" routerLink="/contact"
                 [core-analytics]="{action: 'Get in touch', category: 'TOP-NAV'}"
                 class="btn btn-primary mb-0">{{'Get in touch?' | translate}}</a>
            </span>
          </div>

        </ul>
      </div>
    </div>
  </nav>
</ng-container>
